<template>
	<div class="modal">
		<div class="content">
			<div class="button_close" @click="hideDetails">X</div>
			<div class="project-name">
				<div class="project-year">{{project_details.year}}</div>
				<div>{{project_details.name}}</div>
			</div>
			<img alt="project image" v-if="main_image_exists" class="main-image" :src="main_image" @error="main_image_exists = false" />
			<div id="project-details" class="details">
				<div class="top-part">
					<p class="project-client">
						<span class="text-bold">{{project_details.client}}</span> <span class="text-smal dim-text"> ({{project_details.duration}})</span>
					</p>
					<p v-html="project_details.description" class="project-description" />
					<div class="other-images">
						<img 
							v-show="main_image_loaded"
							@load="mainImageLoaded"
							v-for="(image, index) in project_details.images.others " 
							:key="index"
							:src="'/img/jpg/projects'+image" />
					</div>
				</div>
				<p class="project-services">
					<span class="text-bold">Services rendered:</span>
					<ul v-for="(service, index) in project_details.services" :key="index" :index="index" >
						<li >{{service}}</li>
					</ul>
				</p>
				<button class="button_close" @click="hideDetails">close</button>
			</div>
		</div>
	</div>
</template>

<script>

import  emitter  from '@/emitter';
export default {
	name: 'projects',
	metaInfo: {
		title: 'Project Details',
		// override the parent template and just use the above title only
		// titleTemplate: null
	},
	props: {
		project_details: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			main_image_exists: true,
			main_image_loaded: false,
			main_image: '/img/jpg/projects' + this.project_details.images.main
		};
	},
	mounted() {
		const bounding_rect = document.querySelector('#project-details').getBoundingClientRect();
		document.querySelector('#app').scrollBy({
			left: 0, 
			top: bounding_rect.top - 120,
			behavior: 'smooth'
		});
	},
	methods: {
		hideDetails() {
			emitter.$emit('hide-project-details');
			this.$router.push(this.$route.path);
		},
		mainImageLoaded() {
			this.main_image_loaded = true;
		}
	}
};
</script>
<style lang="scss" scoped>
	@import '../assets/style/main.scss';
	
	$box-shadow: 6px 2px 10px 0.3px rgba(26, 26, 26, 0.4);
	div {
		word-break: normal;
	}
	.dim-text {
		color: $white-light-tr-1;
	}
	.content {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		justify-content: flex-start;
		align-content: stretch;
		max-width: 1024px;
		width: 100%;
		min-height: calc(100vh - 128px);
		margin: 0px auto;
		animation: slide-up 500ms ease-in-out both;

		>.main-image {
			height: 45vh;
			margin-top: 4em;
			margin-top: 0em;
			transition: all 500ms ease-in-out;
			object-fit: cover;
			margin-left: 0%;
			width: 100%;
			align-self: center;
			border-radius: 0px;
			box-shadow: $box-shadow;
		}
		>.button_close {
			user-select: none;
			font-size: 1.3em;
			background-color: $white;
			border-radius: 50%;
			color: $black-light-tr-1;
			margin-left: auto;
			width: 1.8em;
			height: 1.8em;
			display: flex;
			align-self: flex-start;
			align-items: center;
			justify-content: center;
			box-shadow: $box-shadow;
			&:hover {
				cursor: pointer;
				color: $white;
				background-color: $black-light-tr-1;
			}
		}
		>.project-name {
			margin-left: 2em;
			display: flex;
			align-self: flex-start;
			align-items: center;
			justify-content: center;
			height: 7em;
			z-index: 1;
			position: relative;
			padding: 1em;
			font-size: 1.2em;
			color: $white;
			&::before {
				z-index: -1;
				position: absolute;
				left: 0px;
				top: -30%;
				content: '';
				width: 100%;
				height: 160%;
				box-shadow: $box-shadow;
				@include gradient-gray();
			}
			&::after {
				content: '';
				z-index: -2;
				position: absolute;
				left: -2em;
				height: 2em;
				width: 100vw;
				max-width: 1024px;
				box-shadow: $box-shadow;
				background-color: $red-light;
			}

			>.project-year {
				position: absolute;
				bottom: -10%;
				font-size: 1.6em;
				font-weight: 300;
				letter-spacing: 0.3ch;
			}
		}
		>.details {
			opacity: 0;
			animation: flip-in-up 500ms 150ms ease-in-out both;
			box-shadow: $box-shadow;
			background-color: $white;
			margin: 2em 0em 0em 0em;
			align-self: stretch;
			flex-grow: 1;

			line-height: 1.5em;
			letter-spacing: 0.04ch;
			
			>.top-part {
				padding: 1em;
				color: $white;
				background-color: $gray;

				>.project-client {
					margin: 0px;
					font-size: 1.2em;
				}
				>.project-description {
					font-size: 1.1em;
				}
				
				>.other-images {
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
					>img {
						width: 17em;
						height: 17em;
						object-fit: cover;
						border-radius: $border-radius-1;
						
						&:nth-of-type(n + 2) {
							margin-left: 1em;
						}
					}
				}
			}
			>.project-services {
				font-size: 1.1em;
				margin: 1em;
			}
			>.button_close {
				display: flex;
				margin: 1em 1em 1em auto;
				color: $white;
				padding: 0.1em 2em 0.25em 2em;
				font-size: 1.3em;
				border: none;
				background-color: $gray;
				box-shadow: $box-shadow;
				&:hover {
					cursor: pointer;
					color: $white;
					background-color: $black-light-tr-1;
				}
			}
		}
	}
	
	@media (max-width: 767px) {
		.content {
			>.main-image {
				margin-left: 0%;
				width: 100%;
				border-radius: $border-radius-1;
				align-self: flex-start;
			}
			>.project-name {
				&::after {
					width: calc(100vw - 1.5em);
				}
			}
			>.details {
				>.top-part {
					>.other-images {
						>img {
							width: 75% !important;
							max-width: 300px;
							height: unset;
							margin-bottom: 1em;
							margin-left: 1em !important;
						}
					}
				}
			}
		}
		
	}
	@media (min-width: 768px){
	}
</style>